import { apiUri } from '../appConfig';
import handleErrorRequest from './handleErrorRequest';

const promotionDetail = (id) => (
	fetch(`${apiUri}/promotion/${id}`)
		.then((res) => handleErrorRequest(res))
);

export default promotionDetail;



// WEBPACK FOOTER //
// ./src/js/request/promotionDetail.js